(() => {
  const money = (cents, currency) => new Intl.NumberFormat(document.documentElement.lang || 'en', {
    style: 'currency', currency: currency || window.Shopify?.currency?.active || 'USD',
  }).format(Number(cents || 0) / 100);
  const hydrate = async (node) => {
    if (node.dataset.pageperfectHydrated === 'true') return;
    const handle = (node.dataset.shopifyPrice || '').trim().toLowerCase();
    if (!handle || !/^[a-z0-9][a-z0-9-]*$/.test(handle)) return;
    const serverText = node.textContent.trim();
    node.dataset.shopifyPrice = handle;
    node.dataset.pageperfectHydrated = 'true'; node.setAttribute('aria-busy', 'true');
    try {
      const response = await fetch(`${window.Shopify?.routes?.root || '/'}products/${handle}.js`, { credentials: 'same-origin' });
      if (!response.ok) throw new Error(`Shopify returned ${response.status}`);
      const product = await response.json();
      const price = product.price_min ?? product.price;
      const varies = Number(product.price_max ?? price) > Number(price);
      node.textContent = `${varies ? 'From ' : ''}${money(price, product.currency)}`;
      node.dataset.shopifyPriceCents = String(price);
    } catch (error) {
      if (!serverText) node.textContent = 'See current price';
      node.dataset.pageperfectPriceError = error instanceof Error ? error.message : 'Price unavailable';
    } finally { node.removeAttribute('aria-busy'); }
  };
  const placeSecondaryH1 = () => {
    const source = document.querySelector('[data-pageperfect-resource="product"][data-pageperfect-secondary-h1-text]');
    const text = source?.dataset.pageperfectSecondaryH1Text?.trim();
    if (!text) return;
    const existing = Array.from(document.querySelectorAll('[data-pageperfect-secondary-h1]')).find((node) => {
      const rect = node.getBoundingClientRect();
      const style = getComputedStyle(node);
      return rect.width > 0 && rect.height > 0 && style.display !== 'none' && style.visibility !== 'hidden';
    });
    if (existing) return;
    const primary = Array.from(document.querySelectorAll('h1.product-details-product-title, .product__title h1, h1.product__title')).find((node) => {
      const rect = node.getBoundingClientRect();
      const style = getComputedStyle(node);
      return rect.width > 0 && rect.height > 0 && style.display !== 'none' && style.visibility !== 'hidden';
    });
    if (!primary) return;
    const heading = document.createElement('h1');
    heading.className = 'pageperfect-secondary-h1';
    heading.dataset.pageperfectSecondaryH1 = '';
    heading.textContent = text;
    primary.insertAdjacentElement('afterend', heading);
  };
  const run = (root = document) => {
    root.querySelectorAll('.loud-shopify-price[data-shopify-price]').forEach(hydrate);
    placeSecondaryH1();
  };
  document.readyState === 'loading' ? document.addEventListener('DOMContentLoaded', () => run()) : run();
  document.addEventListener('shopify:section:load', (event) => run(event.target));
  if (document.querySelector('[data-pageperfect-resource="product"][data-pageperfect-secondary-h1-text]')) {
    let queued = false;
    new MutationObserver(() => {
      if (queued) return;
      queued = true;
      requestAnimationFrame(() => { queued = false; placeSecondaryH1(); });
    }).observe(document.body, { childList: true, subtree: true });
  }
})();
